import { subDays, subHours, subYears } from "date-fns";
import type { RangePickerProps } from "rc-picker";

/** Returns the standard time ranges offered by frontend date pickers. */
export const defaultRangePresets: ({
  includeTime,
}: {
  includeTime: boolean;
}) => RangePickerProps<Date>["presets"] = ({ includeTime }) => {
  const end = new Date();
  return [
    {
      label: includeTime ? "Last 24 hours" : "Last day",
      value: [subHours(end, 24), end],
    },
    {
      label: "Last 7 days",
      value: [subDays(end, 7), end],
    },
    {
      label: "Last 30 days",
      value: [subDays(end, 30), end],
    },
    {
      label: "Last 90 days",
      value: [subDays(end, 90), end],
    },
    {
      label: "Last year",
      value: [subYears(end, 1), end],
    },
  ];
};
